import React from 'react';
import { useTranslation } from 'react-i18next';
import { MessageCircle, FileText, Settings, Users } from 'lucide-react';

const OurProcess = () => {
  const { t } = useTranslation();

  const steps = [
    {
      id: 1,
      titleKey: 'process.step1',
      descKey: 'process.step1Desc',
      icon: MessageCircle,
    },
    {
      id: 2,
      titleKey: 'process.step2',
      descKey: 'process.step2Desc',
      icon: FileText,
    },
    {
      id: 3,
      titleKey: 'process.step3',
      descKey: 'process.step3Desc',
      icon: Settings,
    },
    {
      id: 4,
      titleKey: 'process.step4',
      descKey: 'process.step4Desc',
      icon: Users,
    },
  ];

  return (
    <section
      id="process"
      style={{
        background: 'var(--bg-page)',
        padding: '5rem 1.2rem',
        position: 'relative',
      }}
    >
      <div className="container">
        <div style={{ textAlign: 'center', marginBottom: '3rem', maxWidth: '800px', margin: '0 auto 3rem' }}>
          <h2 className="heading-1" style={{ marginBottom: '1rem' }}>
            {t('process.title')}
          </h2>
          <p className="body-large" style={{ color: 'var(--text-secondary)' }}>
            {t('process.subtitle')}
          </p>
        </div>

        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '2rem',
            maxWidth: '800px',
            margin: '0 auto',
            position: 'relative',
          }}
        >
          <div
            style={{
              position: 'absolute',
              left: '2rem',
              top: '2rem',
              bottom: '2rem',
              width: '2px',
              background: 'linear-gradient(to bottom, var(--tech-green-500), var(--tech-green-300))',
              zIndex: 1,
            }}
          />

          {steps.map((step) => {
            const IconComponent = step.icon;
            return (
              <div
                key={step.id}
                style={{
                  display: 'flex',
                  gap: '1.5rem',
                  alignItems: 'flex-start',
                }}
              >
                <div style={{ flex: '0 0 auto' }}>
                  <div
                    style={{
                      width: '4rem',
                      height: '4rem',
                      borderRadius: '50%',
                      background: 'linear-gradient(135deg, #22c55e 0%, #16a34a 100%)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: 'white',
                      position: 'relative',
                      zIndex: 2,
                      boxShadow: '0 4px 15px rgba(34, 197, 94, 0.4), 0 0 20px rgba(34, 197, 94, 0.3)',
                      border: '2px solid rgba(34, 197, 94, 0.6)',
                    }}
                  >
                    <IconComponent size={24} strokeWidth={2.5} />
                  </div>
                </div>

                <div
                  style={{
                    flex: 1,
                    background: 'rgba(255, 255, 255, 0.05)',
                    borderRadius: '1rem',
                    padding: '1.5rem',
                    border: '1px solid rgba(34, 197, 94, 0.2)',
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '0.5rem' }}>
                    <span
                      style={{
                        background: 'rgba(34, 197, 94, 0.2)',
                        color: '#22c55e',
                        padding: '0.25rem 0.75rem',
                        borderRadius: '1rem',
                        fontSize: '0.75rem',
                        fontWeight: '600',
                      }}
                    >
                      Step {step.id}
                    </span>
                  </div>
                  <h3 className="heading-3" style={{ marginBottom: '0.5rem', color: 'var(--text-light)' }}>
                    {t(step.titleKey)}
                  </h3>
                  <p className="body-small" style={{ color: 'var(--text-secondary)' }}>
                    {t(step.descKey)}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default OurProcess;
